import { CommonModule } from '@angular/common';
import { NgModule, RendererFactory2 } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';

import { DataSheetComponent } from './data-sheet.component';
import { DevOptionsComponent } from './dev-options.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatTableModule,
    MatRadioModule,
  ],
  exports: [],
  declarations: [DevOptionsComponent, DataSheetComponent],
  providers: [],
})
export class DevOptionsModule {
  constructor(
    private readonly rendererFactory: RendererFactory2,
    private readonly dialog: MatDialog
  ) {
    const renderer = this.rendererFactory.createRenderer(document, null);
    // CTRL + SHIFT + NUM PAD -
    renderer.listen(document, 'keydown.control.shift.-', (e: KeyboardEvent) => {
      this.dialog.open(DevOptionsComponent, {
        width: '600px',
      });
    });
  }
}
